const PATHS = {
  forms: 'M7 3.5h7l4 4V20a.5.5 0 0 1-.5.5h-10A1.5 1.5 0 0 1 6 19V5a1.5 1.5 0 0 1 1-1.5zM14 3.5V8h4M9 12h6M9 15.5h6',
  submissions: 'M6.5 4h11A1.5 1.5 0 0 1 19 5.5v13a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 5 18.5v-13A1.5 1.5 0 0 1 6.5 4zM8.5 9h7M8.5 12.5h7M8.5 16h4',
  clock: 'M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16zM12 8v4.3l2.8 1.7',
  alert: 'M12 4.5 3.5 19.5h17L12 4.5zM12 10v4.2M12 17h.01',
  search: 'M10.5 4.5a6 6 0 1 0 0 12 6 6 0 0 0 0-12zM15 15l4.5 4.5',
  plus: 'M12 5v14M5 12h14',
  more: 'M6 12h.01M12 12h.01M18 12h.01',
  moreVertical: 'M12 6h.01M12 12h.01M12 18h.01',
  back: 'M19 12H5M11 6l-6 6 6 6',
  eye: 'M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12zM12 9.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z',
  text: 'M4 7V5h16v2M12 5v14M9 19h6',
  textarea: 'M4 6h16M4 10h16M4 14h16M4 18h10',
  email: 'M4 6.5h16v11H4zM4.5 7l7.5 6 7.5-6',
  phone: 'M6.5 4h3l1.5 4-2 1.2a10 10 0 0 0 5.8 5.8L16 13l4 1.5v3a1.5 1.5 0 0 1-1.6 1.5A15 15 0 0 1 5 5.6 1.5 1.5 0 0 1 6.5 4z',
  select: 'M5 4.5h14a.5.5 0 0 1 .5.5v14a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5V5a.5.5 0 0 1 .5-.5zM8.5 10.5 12 14l3.5-3.5',
  radio: 'M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16zM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6z',
  checkbox: 'M5 4.5h14a.5.5 0 0 1 .5.5v14a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5V5a.5.5 0 0 1 .5-.5zM8.5 12l2.5 2.5 4.5-5',
  file: 'M7 17.5A4 4 0 0 1 7.5 9.6a5 5 0 0 1 9.6 1.4A3.3 3.3 0 0 1 17 17.5M12 12v7.5M9.5 14.5 12 12l2.5 2.5',
  date: 'M5 6h14v13.5H5zM8.5 4v3.5M15.5 4v3.5M5 10.5h14',
  url: 'M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1',
  heading: 'M6 5v14M18 5v14M6 12h12M4 5h4M16 5h4M4 19h4M16 19h4',
  divider: 'M4 12h16M12 4v3M12 17v3M9.5 6 12 3.5 14.5 6M9.5 18l2.5 2.5 2.5-2.5',
  paragraph: 'M10 19V5h7M14 5v14M10 12.5a3.8 3.8 0 0 1 0-7.5',
  grip: 'M9 6h.01M15 6h.01M9 12h.01M15 12h.01M9 18h.01M15 18h.01',
  globe: 'M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16zM4 12h16M12 4c2.2 2.3 3.2 5 3.2 8s-1 5.7-3.2 8c-2.2-2.3-3.2-5-3.2-8s1-5.7 3.2-8z',
  general: 'M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM12 3.5v2.2M12 18.3v2.2M3.5 12h2.2M18.3 12h2.2M6 6l1.6 1.6M16.4 16.4 18 18M18 6l-1.6 1.6M7.6 16.4 6 18',
  bell: 'M6.5 16.5V11a5.5 5.5 0 0 1 11 0v5.5l1.5 1.5H5l1.5-1.5zM10 20.5h4',
  portal: 'M5 4.5h14v15H5zM8.5 9h7M8.5 12.5h7M8.5 16h4',
  integrations: 'M7 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4zM17 15a2 2 0 1 0 0 4 2 2 0 0 0 0-4zM9 7h4a3 3 0 0 1 3 3v5M7 9v8M5 17h4',
  users: 'M9 5.5a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM3.5 19a5.5 5.5 0 0 1 11 0M16 6a2.5 2.5 0 0 1 0 5M17.5 14a4.5 4.5 0 0 1 3 5',
  advanced: 'M4 7h9M17 7h3M4 17h3M11 17h9M15 5v4M9 15v4',
  copy: 'M9 9h10v11H9zM15 9V5H5v11h4',
  trash: 'M4.5 7h15M9.5 7V4.5h5V7M6.5 7l1 12.5h9l1-12.5M10 11v5M14 11v5',
  download: 'M12 4v11M7.5 10.5 12 15l4.5-4.5M5 19.5h14',
  x: 'M6 6l12 12M18 6 6 18',
  check: 'M5 12.5 9.5 17 19 7.5',
  chevronDown: 'M6 9.5 12 15.5 18 9.5',
  chevronLeft: 'M14.5 6 8.5 12l6 6',
  chevronRight: 'M9.5 6l6 6-6 6',
  zap: 'M13 3.5 5 13.5h6l-1 7 8-10h-6l1-7z',
  edit: 'M5 19h3.5L19 8.5 15.5 5 5 15.5V19zM13.5 7l3.5 3.5',
  external: 'M14 4.5h5.5V10M19.5 4.5 11 13M17 14v5H5V7h5',
  inbox: 'M4 13l2.2-7.2A2 2 0 0 1 8.1 4.5h7.8a2 2 0 0 1 1.9 1.3L20 13v6a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 19v-6zM4 13h4.2l1.3 2h5l1.3-2H20',
  template: 'M6 4.5h12v15H6zM9 8.5h6M9 12h6M9 15.5h3',
  send: 'M20 4 3.5 10.5 10 13l2.5 6.5L20 4zM10 13l4-4',
  folder: 'M4.5 6.5A1.5 1.5 0 0 1 6 5h4l2 2h6a1.5 1.5 0 0 1 1.5 1.5V18a1.5 1.5 0 0 1-1.5 1.5H6A1.5 1.5 0 0 1 4.5 18V6.5z',
  lock: 'M6.5 11h11v9h-11zM8.5 11V8a3.5 3.5 0 0 1 7 0v3',
  code: 'M9 7 4 12l5 5M15 7l5 5-5 5',
  note: 'M5 4.5h14v10l-5 5H5zM14 19.5v-5h5',
};

/**
 * @param {{ name: keyof typeof PATHS | string; size?: number; className?: string; strokeWidth?: number }} props
 */
export function FormIcon({ name, size = 18, className, strokeWidth = 1.8 }) {
  const d = PATHS[name] || PATHS.forms;
  const isDots = name === 'more' || name === 'moreVertical' || name === 'grip';
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={isDots ? 3 : strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <path d={d} />
    </svg>
  );
}
